import { createInvoiceTourStep } from '../config/virtualTour.registry'

export type TourCatalogPort = {
  createStep: typeof createInvoiceTourStep
}

export const defaultTourCatalogPort: TourCatalogPort = {
  createStep: createInvoiceTourStep,
}
